import React, { memo } from 'react';

const RowActionItems = (props) => {
  return <div className="with-btn text-nowrap d-flex justify-content-center">{props.children}</div>;
};

export default memo(RowActionItems);
